import axios from '~src/api/axios';
import { stringify } from 'query-string';
import { URLS } from '~src/api/urls';
import withCookieData from '~utils/withCookieData';
import analytics from '~api/analytics';
import { APP_IDS, COMPONENT_IDS, PAGE_IDS, UiIds } from '~src/constants';
import getCsrfToken from '~utils/getCsrfToken';
import { uiIdsToNames } from '~contextProviders/uiIds/helpers';
import { arrayContains, arrayEquals } from '~api/helpers/helpers';

type Body = {
  name?: string;
  phone: string;
  email: string;
  idd: string | number;
  uiIds?: UiIds;
};

type Args = {
  data: Body;
  url: string;
};

function oldApi({ data, url }: Args) {
  return axios.post(
    URLS.old.getPrezFormUrl(url),
    stringify({
      'PrezaForm[name]': data.name,
      'PrezaForm[phone]': data.phone,
      'PrezaForm[email]': data.email,
      idd: data.idd,
      pdf_comment: `Клиент скачал презу по ${data.idd}`,
      _csrf_frontend: getCsrfToken(),
    }),
  );
}

async function apartmentsPdf({ data }: Args) {
  // FormID: apartments.mcity.ru, Получить PDF на почту

  const _data = {
    // name: name,
    phone: data.phone,
    email: data.email,
    object_id: data.idd,
    // object_url: url,
    // pdf_comment: `Клиент скачал презу по ${idd}`,
    // _csrf_frontend: getCsrfToken(),
  };

  const result = await axios.post(
    URLS.v1.prezForm,
    stringify(withCookieData(_data, 'roistat_visit')),
  );
  // const result = await oldApi({data, url})

  analytics.goal.ym({
    labels: ['apartments.mcity.ru', 'apartments-complex'],
  });
  analytics.goal.ym({ labels: 'apartments-pdf', data: _data });
  analytics.goal.ga({
    category: 'apartments.mcity.ru',
    action: 'form_submit',
    labels: [null, 'apartments-complex'],
  });

  return result;
}

async function mcityPdfFromSearch({ data }: Args) {
  // FormID: mcity.ru, Получить PDF на почту с поиска

  const _data = {
    phone: data.phone,
    email: data.email,
    object_id: data.idd,
    // _csrf_frontend: getCsrfToken(),
  };

  const result = await axios.post(
    URLS.v2.prezForm,
    stringify(withCookieData(_data, 'roistat_visit')),
  );
  // const result = await oldApi({data, url})

  analytics.goal.ym({ labels: ['mcity.ru'] });
  analytics.goal.ym({ labels: ['mcity-search', 'mcity-pdf'], data: _data });
  analytics.goal.ga({
    category: 'mcity.ru',
    action: 'form_submit',
    labels: [null, 'mcity-search', 'mcity-pdf'],
  });

  return result;
}

async function mcityPdfFromObject({ data }: Args) {
  // FormID: mcity.ru, Получить PDF на почту с объекта

  const _data = {
    name: data.name,
    phone: data.phone,
    email: data.email,
    object_id: data.idd,
    // _csrf_frontend: getCsrfToken(),
  };

  const result = await axios.post(
    URLS.v2.objectPrezForm,
    stringify(withCookieData(_data, 'roistat_visit')),
  );
  // const result = await oldApi({data, url})

  analytics.goal.ym({ labels: ['mcity.ru'] });
  analytics.goal.ym({ labels: ['mcity-object', 'mcity-pdf'], data: _data });
  analytics.goal.ga({
    category: 'mcity.ru',
    action: 'form_submit',
    labels: [null, 'mcity-object', 'mcity-pdf'],
  });

  return result;
}

export default function postGetPresentationForm(args: Args) {
  console.log(
    'postGetPresentationForm',
    JSON.stringify(
      { ...args, data: { ...args.data, uiIds: uiIdsToNames(args.data.uiIds) } },
      null,
      2,
    ),
  );

  if (
    arrayEquals(args.data.uiIds?.appIds, [APP_IDS.apartments]) &&
    arrayEquals(args.data.uiIds?.pageIds, [PAGE_IDS.Complex]) &&
    arrayContains(args.data.uiIds?.componentIds, [
      COMPONENT_IDS.ObjectDetailsWithGalleryAndPreviewButtons,
    ])
  ) {
    return apartmentsPdf(args);
  }

  if (
    arrayEquals(args.data.uiIds?.appIds, [APP_IDS.mcity]) &&
    arrayContains(args.data.uiIds?.componentIds, [
      COMPONENT_IDS.Search,
      COMPONENT_IDS.Listing,
      COMPONENT_IDS.ObjectDetailsWithGalleryAndPreviewButtons,
    ])
  ) {
    return mcityPdfFromSearch(args);
  }

  if (
    arrayEquals(args.data.uiIds?.appIds, [APP_IDS.mcity]) &&
    arrayContains(args.data.uiIds?.componentIds, [COMPONENT_IDS.PreviewForm])
  ) {
    return mcityPdfFromObject(args);
  }

  return oldApi(args);
}
